import React from 'react';
import { getAllProfiles } from '../../utils/imageCompression';
import { useSettings } from '../../contexts/SettingsContext';
import ProfileCard from './ProfileCard';
import ProfileTester from './ProfileTester';
import CustomProfileForm from './CustomProfileForm';

function CompressionSettings() {
  const { settings, setActiveProfile } = useSettings();
  const profiles = getAllProfiles();
  const activeProfileId = settings.compression.activeProfile;

  const handleProfileSelect = (profileId) => {
    console.log('[CompressionSettings] Profile selected:', profileId);
    setActiveProfile(profileId);
  };

  return (
    <div className="compression-settings">
      <div className="settings-section">
        <h3>Screenshot Capture Settings</h3>
        <p>Choose a compression profile to optimize for quality or speed</p>
      </div>

      <div>
        <h4 className="compression-section-title">Compression Profiles</h4>
        <div className="profile-grid">
          {profiles.map((profile) => (
            <ProfileCard
              key={profile.id}
              profile={profile}
              isActive={activeProfileId === profile.id}
              onClick={() => handleProfileSelect(profile.id)}
            />
          ))}
        </div>
      </div>

      <CustomProfileForm />

      <ProfileTester />
    </div>
  );
}

export default CompressionSettings;

